module.exports = __webpack_public_path__ + "img/starcraft-ii.5734fd5b.svg";